/**
 * Shared homepage video performance controller.
 * - Pauses background videos when substantially off-screen, resumes
 *   when back in view (IntersectionObserver), instead of letting all
 *   of them play simultaneously regardless of visibility.
 * - Respects prefers-reduced-motion: videos are never autoplayed;
 *   the browser's already-loaded first frame stands in as a static
 *   fallback (no separate poster asset exists to swap in).
 * - Muted/playsinline are left exactly as already set in the markup.
 */
(function () {
  if (window.__igniteVideoObserverInit) return;
  window.__igniteVideoObserverInit = true;

  var SELECTOR =
    '.ignite-hero__video, .ignite-project__video, .ignite-work__statement-video';

  function setup() {
    var reduceMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    var videos = document.querySelectorAll(SELECTOR);
    if (!videos.length) return;

    if (reduceMotion) {
      videos.forEach(function (video) {
        video.removeAttribute('autoplay');
        video.pause();
      });
      return;
    }

    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting && entry.intersectionRatio > 0.15) {
            var playPromise = video.play();
            if (playPromise && playPromise.catch) {
              playPromise.catch(function () {
                // Autoplay can still be blocked (e.g. iOS Low Power
                // Mode) — the video simply stays on its current
                // frame, which is an acceptable static fallback.
              });
            }
          } else {
            video.pause();
          }
        });
      },
      { threshold: [0, 0.15, 0.5] }
    );

    videos.forEach(function (video) {
      observer.observe(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
